const routeNames = {
  loginEmail: () => '/login',
  loginPassword: () => '/login/password',
  loginMfa: () => '/login/mfa',
  home: () => '/',

  forgotPassword: () => '/forgot-password',
  acceptInvitation: () => '/accept',
  missingInvitation: () => '/missing-invitation',
  token: (tokenId = ':token') => `/token/${tokenId}`,

  myProfile: () => '/profile',
  myProfileInfo: () => '/profile',
  myProfileAccount: () => '/profile/account',

  profileName: () => '/profile/info/name',
  profilePhoto: () => '/profile/info/photo',
  profileResidence: () => '/profile/info/residence',
  profilePhotoInvalid: () => '/profile/info/photo/invalid',
  profileLanguage: () => '/profile/account/language',
  profileEmail: () => '/profile/account/email',
  profilePassword: () => '/profile/account/password',
  profileMfaEnabled: () => '/profile/account/mfa/enabled',
  profileMfaSetup: () => '/profile/account/mfa/setup',

  leaveGroup: () => '/profile/account/leave-group',
  goodbyeGroup: () => '/goodbye-group',

  medicalTerms: () => '/medical-terms',
  medicalTermsCategory: (category = ':category') => `/medical-terms/${category}`,

  groupUsers: () => '/users',
  groupUsersActive: () => '/users/active',
  groupUsersPending: () => '/users/pending',
  groupUsersDeactivated: () => '/users/deactivated',

  groupSettings: () => '/settings',
  groupName: () => '/settings/name',
  groupUrl: () => '/settings/url',
  groupAppearance: () => '/settings/appearance',
  confirmDeleteGroup: () => '/settings/delete-group',
  groupEditDefaultLanguage: () => '/settings/default-language',
  groupEditDiscoverability: () => '/settings/discoverability',
  groupDeleted: () => '/group-deleted',
  groupSetup: () => '/group-setup',
  groupSetupSuccess: () => '/group-setup-success',
  groupInfo: () => '/group-info',
  groupOrganizationName: () => '/settings/organization-name',
  groupEditAbout: () => '/group-info/about',
  groupEditContact: () => '/group-info/contact',
  groupEditKeywords: () => '/group-info/keywords',
  groupEditEligibility: () => '/group-info/eligibility',
  groupEditExternalButton: () => '/group-info/external-button',
  groupEditOrganizationDetails: () => '/settings/organization-details',
  groupEditResearchFocus: () => '/settings/research-focus',
  groupEditMemberCount: () => '/group-info/member-count',
  groupEditPhotoGallery: () => '/group-info/gallery',

  shareCardContent: () => '/card-content',
  shareCardContentEditor: (id) => `/card-content/editor/${id}`,

  resources: () => '/resources',
  resourcesEditor: (id) => `/resources/editor/${id}`,

  surveys: () => '/surveys',
};

export default routeNames;
